var hash = {
  start: 'end',
  end: 'start'
};
export default function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/.store/@popperjs+core@2.9.2/~/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
// module id = 584
// module chunks = 75